<template>
  <div class="activity-turntable">
    <img class="img" :src="truntable.activityBackground" alt="">
    <section class="warp">
      <img :src="truntable.couponPicture" alt="">
      <!-- <div v-if="truntable.isPrint === 'true'" class="reprintBtn" :style="{background:'url('+truntable.reprintBtn+') no-repeat'}">分享领券8.88元无门槛红包</div>
      <div v-else class="reprintBtn" :style="{background:'url('+truntable.receiveBtn+') no-repeat'}">立即领取</div> -->
    </section>
  </div>
</template>
<script>
export default {
  name: "activity-turntable",
  data() {
    return {
      activityId: this.$route.query.activityId,
      aid: this.$route.query.aid,
      truntable: ""
    };
  },
  created() {
    this.getActivity();
  },
  methods: {
    getActivity() {
      this.service.getCouponActivityDetail(this.activityId).then(res => {
        console.log(res);
        if (res.success) {
          this.truntable = res.data;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.activity-turntable {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
  }
  .warp {
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 999;
    text-align: center;
    img {
      width: 9rem;
      height: 3.3rem;
      overflow: hidden;
      margin: 56.5vh auto 0 auto;
    }
    .reprintBtn {
      background-size: contain !important;
      border-radius: 0.6rem;
    }
    div {
      font-size: 0.4rem;
      text-align: center;
      height: 1.1rem;
      width: 7rem;
      color: red;
      margin: 12vh auto;
      line-height: 1.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// activityTurntable.vue?0fe424f4